// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__KHSDw","label":"Radio_label__3T1Tl","checkMark":"Radio_checkMark__3YuS6","disabled":"Radio_disabled__S9VmN"};